import { DatePickerStoreConsumer as e, DatePickerStoreProvider as t } from "../core/models/provider.js";
import { CalendarView as n } from "./calendar-view.js";
import { MonthView as r } from "./month-view.js";
import { yearView as i } from "./year-view.js";
import { ContextToggler as a } from "./context-toggle.js";
import { TodayButton as o } from "./today-button.js";
import { Input as s } from "./input.js";
import { CalendarPopover as c } from "./calendar-popover.js";
import { ViewSwitcher as l } from "./view-switcher.js";
import { useCallbackRef as u } from "../hooks/use-callback-ref.js";
import { jsx as d } from "react/jsx-runtime";
// src/design/forms/datepicker/ui/index.tsx
var f = ({ children: e, onChange: n, onError: r, onToggleChange: i, ...a }) => {
	let o = u(n), s = u(r), c = u(i);
	return /* @__PURE__ */ d(t, {
		props: {
			...a,
			onChange: o,
			onError: s,
			onToggleChange: c
		},
		children: e
	});
};
f.Input = s, f.Toggler = a, f.CalendarView = n, f.MonthView = r, f.YearView = i, f.TodayButton = o, f.CalendarPopover = c, f.ViewSwitcher = l, f.Consumer = e;
export { f as DatePicker };

//# sourceMappingURL=index.js.map